import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslate } from '@tolgee/react';

import { useAuthService } from "../../Context/AuthContext";
import { getFlag } from "../../Helpers/FlagHandler";

import PrimaryButton from "../GenericComponents/PrimaryButton";

import { ReactComponent as Arrow } from "../../Assets/iconsv2/generic/forwardArrow.svg";
import { ReactComponent as Microphone } from "../../Assets/iconsv2/settings/microphone.svg";
import { ReactComponent as Speaker } from "../../Assets/iconsv2/settings/speaker.svg";
import { ReactComponent as Video } from "../../Assets/iconsv2/settings/video.svg";
import LanguageListSelector from "../Auth Components/LanguageListSelector";
import Select, { components, DropdownIndicatorProps } from "react-select";

import { useMediaDeviceSelect } from "@livekit/components-react";
import LocalStorage from "../../Helpers/LocalStorage";
import { useCallsService } from "../../Context/CallsContext";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

import img1 from "../../Assets/img/1.jpeg";
import img2 from "../../Assets/img/2.jpeg";
import img3 from "../../Assets/img/3.jpeg";
import img4 from "../../Assets/img/4.jpeg";
import img5 from "../../Assets/img/5.jpeg";
import { BLUR_BG, MORE_BLUR_BG, IMAGE_BG, NORMAL_BG } from "../../Constants/constantValues";
import { isSafari } from "react-device-detect";
import { useNotify } from "../../Helpers/Notifications";
import languageSyncManager from "../../Helpers/callHelper/LanguageSyncHelper";
import { useWebSocketDataService } from "../../Context/WebsocketContext";
import { DISABLED_TRANSLATION } from "../../Constants/constantValues";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Arrow />
    </components.DropdownIndicator>
  );
};

const CallsSettings = () => {
  const { t } = useTranslate();
  const { notifySuccess, notifyError, notifyInfo } = useNotify();
  const {
    user,
    updateUser,
    callTranslationsLanguages,
    callTranslationsLanguagesRef,
    userRef,
    handleLoginUser
  } = useAuthService();

  const [selectedLanguage, setSelectedLanguage] = useState(user.call_language);
  const [infoChanged, setInfoChanged] = useState(false);
  const [isLanguageSelectorOpen, setIsLanguageSelectorOpen] = useState(false);
  const {
    selectedAudioInput,
    setSelectedAudioInput,
    selectedVideoInput,
    setSelectedVideoInput,
    selectedAudioOutput,
    setSelectedAudioOutput,
    backgroundType,
    setBackgoundType,
  } = useCallsService();
  const {
    selectedMenuAudioInput,
    setSelectedMenuAudioInput,
    selectedMenuAudioOutput,
    setSelectedMenuAudioOutput,
    selectedMenuVideoInput,
    setSelectedMenuVideoInput,
  } = useGenericComponentsStateService();

  const audioInputDevice = useMediaDeviceSelect({ kind: "audioinput" });
  const audioOutputDevice = useMediaDeviceSelect({ kind: "audiooutput" });
  const videoInputDevice = useMediaDeviceSelect({ kind: "videoinput" });

  const { sendTranslationEnabledMessage } = useWebSocketDataService();
  const { activeCallRef } = useCallsService();

  const theme = useTheme();
  const imagesBg = [img1, img2, img3, img4, img5];
  const handleChangeInputDevice = (deviceId) => {
    audioInputDevice.setActiveMediaDevice(deviceId);
    LocalStorage.setInputDevice(deviceId);
    setSelectedAudioInput(deviceId);
  };

  const handleChangeVideoDevice = (deviceId) => {
    videoInputDevice.setActiveMediaDevice(deviceId);
    LocalStorage.setVideoInputDevice(deviceId);
    setSelectedVideoInput(deviceId);
  };

  const handleChangeOutputDevice = (deviceId) => {
    audioOutputDevice.setActiveMediaDevice(deviceId);
    LocalStorage.setOutputDevice(deviceId);
    setSelectedAudioOutput(deviceId);
  };

  const handleSyncSelectedInput = (deviceId) => {
    let found = audioInputDevice.devices.find(
      (item) => item.deviceId === deviceId
    );
    setSelectedMenuAudioInput(found);
  };
  const handleSyncSelectedVideoInput = (deviceId) => {
    let found = videoInputDevice.devices.find(
      (item) => item.deviceId === deviceId
    );
    setSelectedMenuVideoInput(found);
  };

  const handleSyncSelectedOutput = (deviceId) => {
    let found = audioOutputDevice.devices.find(
      (item) => item.deviceId === deviceId
    );
    setSelectedMenuAudioOutput(found);
    if (audioOutputDevice.activeDeviceId === "") {
      let defaultDevice = audioOutputDevice.devices.find(
        (item) => item.deviceId === "default"
      );
      if (defaultDevice) {
        audioOutputDevice.setActiveMediaDevice(defaultDevice.deviceId);
      }
    }
  };

  const selectedCustomStyles = {
    container: (provided) => ({
      ...provided,

      "&:focus-visible": {
        outline: "none",
      },
      width: "100%",
      fontSize: "14px",
      color: theme.menu.primaryTextColor,
    }),

    control: (provided) => ({
      ...provided,
      "&:focus-visible": {
        outline: "none",
      },
      "&:selected": {
        outline: "none",
      },
      "&:hover": {
        boxShadow: "none",
      },

      boxShadow: "none",
      borderColor: theme.menu.groupContentBackground,
      background: theme.menu.groupContentBackground,
      color: theme.menu.primaryTextColor,

      padding: 0,
    }),
    menuList: (provided) => ({
      ...provided,
      background: theme.menu.groupContentBackground,
      color: theme.menu.primaryTextColor,
    }),
    option: (provided, { isSelected }) => ({
      ...provided,
      "&:hover": {
        background: theme.menu.enterPhoneNumberBackground,
        color: theme.menu.selectedTextColor,
      },
      "&:active": {
        background: theme.menu.groupContentBackground,
      },
      "&:selected": {
        background: theme.menu.primaryTextColor,
      },
      background: isSelected ? theme.menu.selectedTextColor : "inherit",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "16px",
      lineHeight: "22px",
      fontWeight: "400",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "16px",
      fontWeight: "500",
      color: theme.menu.primaryTextColor,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),

    indicatorContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
  };

  const verifiyIfCallLanguageIsValid = () => {
    let validLanguage = callTranslationsLanguagesRef.current.find(
      (item) => item.locale === user.call_language
    );
    return validLanguage;
  };

  const checkInfoChanged = () => {
    if (user.call_language !== selectedLanguage) {
      setInfoChanged(true);
    } else {
      setInfoChanged(false);
    }
  };

  const handleUpdateUser = () => {
    var objectData = {};
    if (selectedLanguage !== user.call_language) {
      objectData.call_language = selectedLanguage;
    }
    updateUser(
      objectData,
      function (response) {
        handleLoginUser(response.data.user);

        if (window.electron?.notifyLanguageChanged) {
          window.electron.notifyLanguageChanged(selectedLanguage);
        }
        languageSyncManager.notifyLanguageChanged(selectedLanguage);

        if (activeCallRef.current?.details?.uuid) {
          const currentTranslationType = activeCallRef.current.details.translation_type;
          
          if (currentTranslationType && currentTranslationType !== DISABLED_TRANSLATION) {
            sendTranslationEnabledMessage(
              activeCallRef.current.details.uuid,
              true,
              currentTranslationType
            );
          }
        }

        notifySuccess(`${t('profile.profile_updated')}`);
        setInfoChanged(false);
      },
      function (error) {
        console.log(error, "error");
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  const displaySlectedLanguageFromList = (language) => {
    let found = callTranslationsLanguages.find(
      (item) => item.locale === language
    );
    return found;
  };

  const openLanguageSelector = () => {
    setIsLanguageSelectorOpen(!isLanguageSelectorOpen);
  };

  const handleSetCallLanguage = () => {
    if (!user) {
      return;
    }
    let foundLanguage = verifiyIfCallLanguageIsValid();
    if (foundLanguage) {
      setSelectedLanguage(foundLanguage.locale);
    } else {
      setSelectedLanguage(null);
    }
  };

  const handleVirtualBackground = (bgType, imageLink) => {
    if (imageLink) {
      setBackgoundType(imageLink);
      LocalStorage.setCallVirtualBg(imageLink);
    } else {
      setBackgoundType(bgType);
      LocalStorage.setCallVirtualBg(bgType);
    }
  };

  const filterDefault = (devices) => {
    let filteredDevices = devices.filter((item) => item.deviceId !== "default")
    return filteredDevices
  }

  useEffect(() => {

    if (
      selectedAudioInput &&
      audioInputDevice.devices.find((d) => d.deviceId === selectedAudioInput)
    ) {
      audioInputDevice.setActiveMediaDevice(selectedAudioInput);
    }
    else {
      if (audioInputDevice.devices.length > 0) {
        let filtered = filterDefault(audioInputDevice.devices)
        if (filtered.length > 0) {
          audioInputDevice.setActiveMediaDevice(filtered[0].deviceId);
        }

      }
    }

    if (
      selectedVideoInput &&
      videoInputDevice.devices.find((d) => d.deviceId === selectedVideoInput)
    ) {
      videoInputDevice.setActiveMediaDevice(selectedVideoInput);
    } else {
      if (videoInputDevice.devices.length > 0) {
        let filtered = filterDefault(videoInputDevice.devices)
        if (filtered.length > 0) {
          videoInputDevice.setActiveMediaDevice(filtered[0].deviceId);
        }

      }
    }

    if (
      selectedAudioOutput &&
      audioOutputDevice.devices.find((d) => d.deviceId === selectedAudioOutput)
    ) {
      audioOutputDevice.setActiveMediaDevice(selectedAudioOutput);
    } else {
      if (audioOutputDevice.devices.length > 0) {
        let filtered = filterDefault(audioOutputDevice.devices)
        if (filtered.length > 0) {
          audioOutputDevice.setActiveMediaDevice(filtered[0].deviceId);
        }
      }
    }
  }, [
    audioInputDevice.devices,
    videoInputDevice.devices,
    audioOutputDevice.devices,
    audioInputDevice.activeDeviceId,
    videoInputDevice.activeDeviceId,
    audioOutputDevice.activeDeviceId,
  ]);

  useEffect(() => {
    handleSyncSelectedInput(audioInputDevice.activeDeviceId);
  }, [audioInputDevice]);

  useEffect(() => {
    handleSyncSelectedOutput(audioOutputDevice.activeDeviceId);
  }, [audioOutputDevice]);

  useEffect(() => {
    handleSyncSelectedVideoInput(videoInputDevice.activeDeviceId);
  }, [videoInputDevice]);

  useEffect(() => {
    if (window.electron?.onLanguageChanged) {
      window.electron.onLanguageChanged((language) => {
        setSelectedLanguage(language);
        setInfoChanged(false);
      });
    }
  }, []);

  useEffect(() => {
    const cleanup = languageSyncManager.onLanguageChanged((language) => {
      setSelectedLanguage(language);
      setInfoChanged(false);
    });

    return cleanup;
  }, []);

  useEffect(() => {
    if (user?.call_language !== undefined && user.call_language !== selectedLanguage) {
      setSelectedLanguage(user.call_language);
      setInfoChanged(false);
    }
  }, [user?.call_language]);

  useEffect(() => {
    checkInfoChanged();
  }, [selectedLanguage]);

  useEffect(() => {
    handleSetCallLanguage();
  }, [user, callTranslationsLanguages]);


  return (
    <Container>
      {isLanguageSelectorOpen && (
        <LanguageListSelector
          isLanguageSelectorOpen={isLanguageSelectorOpen}
          openLanguageList={openLanguageSelector}
          valuesList={callTranslationsLanguages}
          setValue={setSelectedLanguage}
          selectedValue={selectedLanguage}
          callLanguage
        />
      )}
      <Header>
        <HeaderTitle>{t('general.calls')}</HeaderTitle>
        {infoChanged && (
          <PrimaryButton
            onClick={() => handleUpdateUser()}
            text={t('general.save')}
          />
        )}
      </Header>

      <ContentWrapper>
        <Content>
          <Group>
            <GroupTitle>{t('settings.language').toUpperCase()}</GroupTitle>
            <GroupDescription>
              {t('settings.chat_settings_call_language_text')}
            </GroupDescription>
            <GroupContentWrapper>
              <OptionWithPicker>
                <OptionWithPickerText style={{ minWidth: "144px" }}>
                  {t('profile.language')}
                </OptionWithPickerText>
                {displaySlectedLanguageFromList(selectedLanguage) ? (
                  <LanguageItem onClick={() => openLanguageSelector()}>
                    <Flag
                      src={getFlag(
                        displaySlectedLanguageFromList(selectedLanguage)
                          ?.country_code
                      )}
                      alt={selectedLanguage}
                    />{" "}
                    {displaySlectedLanguageFromList(selectedLanguage)?.name} (
                    {
                      displaySlectedLanguageFromList(selectedLanguage)
                        ?.translation
                    }
                    )
                    <Arrow style={{ marginLeft: "auto" }} />
                  </LanguageItem>
                ) : (
                  <CustomInput
                    readonly
                    value={"Select language"}
                    onClick={() => openLanguageSelector()}
                  />
                )}
              </OptionWithPicker>
            </GroupContentWrapper>
          </Group>

          <Group>
            <GroupTitle>{t('general.audio')}</GroupTitle>

            <GroupContentWrapper>
              <OptionWithPicker>
                <IconWrapper>
                  <Microphone />
                </IconWrapper>
                <OptionWithPickerText>
                  {t('general.microphone')}
                </OptionWithPickerText>
                <Select
                  components={{ DropdownIndicator }}
                  value={selectedMenuAudioInput}
                  onChange={(e) => handleChangeInputDevice(e.deviceId)}
                  options={filterDefault(audioInputDevice.devices)}
                  isSearchable={false}
                  isOptionSelected={(e) =>
                    audioInputDevice.activeDeviceId === e.deviceId
                  }
                  styles={selectedCustomStyles}
                ></Select>
              </OptionWithPicker>

              {audioOutputDevice.devices.length > 0 && (
                <OptionWithPicker>
                  <IconWrapper>
                    <Speaker />
                  </IconWrapper>
                  <OptionWithPickerText>
                    {t('settings.speaker')}
                  </OptionWithPickerText>
                  <Select
                    components={{ DropdownIndicator }}
                    value={selectedMenuAudioOutput}
                    onChange={(e) => handleChangeOutputDevice(e.deviceId)}
                    options={filterDefault(audioOutputDevice.devices)}
                    isSearchable={false}
                    isOptionSelected={(e) =>
                      audioOutputDevice.activeDeviceId === e.deviceId
                    }
                    styles={selectedCustomStyles}
                  ></Select>
                </OptionWithPicker>
              )}
            </GroupContentWrapper>
          </Group>
          <Group>
            <GroupTitle>{t('general.camera')}</GroupTitle>
            <GroupContentWrapper>
              <OptionWithPicker>
                <IconWrapper>
                  <Video />
                </IconWrapper>
                <OptionWithPickerText>
                  {t('general.camera')}
                </OptionWithPickerText>
                <Select
                  components={{ DropdownIndicator }}
                  value={selectedMenuVideoInput}
                  onChange={(e) => handleChangeVideoDevice(e.deviceId)}
                  options={filterDefault(videoInputDevice.devices)}
                  isSearchable={false}
                  isOptionSelected={(e) =>
                    videoInputDevice.activeDeviceId === e.deviceId
                  }
                  styles={selectedCustomStyles}
                ></Select>
              </OptionWithPicker>
            </GroupContentWrapper>
          </Group>
          {!isSafari && (
            <Group>
              <GroupTitle>{t('settings.background')}</GroupTitle>
              <BackgroundList>
                <BgElement
                  onClick={() => handleVirtualBackground(NORMAL_BG, null)}
                  selected={backgroundType === NORMAL_BG}
                >
                  <p>{t('callOptionModal.none')}</p>
                </BgElement>
                <BlurElement
                  onClick={() => handleVirtualBackground(BLUR_BG, null)}
                  selected={backgroundType === BLUR_BG}
                >
                  <p>{t('callOptionModal.blur')}</p>
                </BlurElement>
                <BlurElement
                  onClick={() => handleVirtualBackground(MORE_BLUR_BG, null)}
                  selected={backgroundType === MORE_BLUR_BG}
                >
                  <p>{t('callOptionModal.more_blur')}</p>
                </BlurElement>
                {imagesBg.map((img, index) => (
                  <ImgElement
                    key={index}
                    onClick={() => handleVirtualBackground(IMAGE_BG, img)}
                    selected={backgroundType === img}
                  >
                    <img src={img} alt={img + "alt"} />
                  </ImgElement>
                ))}
              </BackgroundList>
            </Group>
          )}
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default CallsSettings;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  background: ${({ theme }) => theme.menu.background};
  height: 100%;
  overflow: auto;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 0 auto;
  max-width: 631px;
  width: 100%;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GroupContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;

  padding: 8px 16px;
`;

const Flag = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 100px;
  object-fit: cover;
`;

const GroupTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.04px;
  vertical-align: middle;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  text-transform: uppercase;
`;
const GroupDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const OptionWithPicker = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 8px 0;
`;
const OptionWithPickerText = styled.p`
  min-width: 100px;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.41px;
`;
const LanguageItem = styled.h3`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  color: ${({ selected, theme }) =>
    selected ? theme.menu.selectedTextColor : theme.menu.primaryTextColor};
  background: ${({ selected, theme }) =>
    selected
      ? theme.menu.selectedOpionBackground
      : theme.menu.groupContentBackground};
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  &:last-child {
    border: none;
  }
`;

const CustomInput = styled.input`
  width: 100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.41px;
  &:focus-visible {
    outline: none;
  }
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.menu.secondaryTextColor};
`;
const BackgroundList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const BgElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.menu.background};
  width: 140px;
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  ${({ theme, selected }) =>
    selected && `border:1px solid ${theme.sidebar.selectedIconColor}`};
  p {
    font-size: 16px;
    line-height: 18px;
    font-weight: 500;
    color: ${({ theme }) => theme.menu.secondaryTextColor};
  }
`;
const BlurElement = styled(BgElement)`
  background: ${({ theme }) => theme.menu.avatarBackground};
  box-shadow: inset 0px 0px 50px -3px rgba(0, 0, 0, 0.75);
`;
const ImgElement = styled(BgElement)`
  img {
    width: 100%;
    height: 100%;
  }
`;
